module.exports = __webpack_public_path__ + "static/media/architecture.d932bd1d.jpg";